module.exports = __webpack_public_path__ + "static/media/13.1.5491f16e.png";